<template>
  <v-container style="max-height: 100%; overflow: auto;padding: 20px;">
    <v-row v-if="isAdmin">
      <v-expansion-panels accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('admin.Comissions') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <AdminCommissions />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('admin.Exchange') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <PayExchangeTransactions />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('admin.EditableMessages') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <EditableSystemMessages />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import AdminCommissions from "../components/AdminCommissions";
import EditableSystemMessages from "../components/EditableSystemMessages";
import PayExchangeTransactions from "../components/PayExchangeTransactions";
import Constants from "../../constants";
export default {
    name: "Admin",
    components: {AdminCommissions, EditableSystemMessages, PayExchangeTransactions},
    data () {
        return {
            isAdmin: false
        };
    },
    created () {
        this.isAdmin = this.$user.role === Constants.USER.ROLE_ADMIN;
    }
};
</script>

<style scoped>

</style>
